"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextWidget = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_jss_1 = __importDefault(require("react-jss"));
const textWidget_style_1 = __importDefault(require("./textWidget.style"));
const TextWidget = ({ classes, label = '', value = '' }) => (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [jsx_runtime_1.jsx("div", Object.assign({ className: classes.label }, { children: label }), void 0),
        jsx_runtime_1.jsx("div", Object.assign({ className: classes.value }, { children: value }), void 0)] }, void 0));
exports.TextWidget = TextWidget;
exports.default = react_jss_1.default(textWidget_style_1.default)(exports.TextWidget);
//# sourceMappingURL=index.js.map